import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings'
import { measurements } from '@mobi/component-library/Foundations'
import { shouldApplySafeAreaBottomPadding } from '@core/Settings/cssConditions'

interface BettingDrawerStyledProps {
  open: boolean
}

export const SameRaceMultiBettingDrawerStyled = styled.div({
  transition: 'transform 0.2s',
  backgroundColor: hexColors.white,
  boxSizing: 'border-box',
  borderTop: `0.1rem solid ${hexColors.veryLightGrey}`,
  padding: '6px',
})

export const SameRaceMultiBettingDrawerContainerStyled = styled.div<BettingDrawerStyledProps>(
  {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    transition: 'transform 0.2s',
    boxSizing: 'border-box',
    zIndex: 8,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: measurements.mobi.bottomTabsHeight,
    paddingBottom: shouldApplySafeAreaBottomPadding ? 'var(--safe-area-inset-bottom, 0)' : 0,
  },
  ({ open }) => ({
    transform: `translateY(${open ? 0 : '100%'})`,
  })
)

export const SameRaceMultiBettingDrawerNoticeBoxPositionerStyled = styled.div({
  margin: '10px',
  boxShadow: '0px 0px 5px #aaaa',
})
